import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { CatalogProductsActions } from ".";
import {
  FETCH_CATALOG_PRODUCTS_PROGRESS,
  FETCH_CATALOG_PRODUCTS_SUCCESS,
  FETCH_CATALOG_PRODUCTS_FAILED,
  CLEAR_CATALOG_PRODUCTS_STATE,
} from "./CatalogProductsActions";
import { defaultCatalogProductsState } from "./defaultState";
import { ICatalogProductsState } from "./CatalogProducts.types";

export const catalogProductsReducer = (
  state: IStoreState["catalogProducts"] = defaultCatalogProductsState,
  action: CatalogProductsActions,
) => {
  switch (action.type) {
    case FETCH_CATALOG_PRODUCTS_PROGRESS: {
      const newState = produce(state, (draftState: ICatalogProductsState) => {
        draftState.list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_CATALOG_PRODUCTS_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState: ICatalogProductsState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_CATALOG_PRODUCTS_FAILED: {
      const newState = produce(state, (draftState: ICatalogProductsState) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_CATALOG_PRODUCTS_STATE: {
      return defaultCatalogProductsState;
    }
    default:
      return state;
  }
};
